import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHttp } from '@core/api/api-http';
import { OpportunityApiHttp } from '@core/api/opportunity-api-http';

@Injectable({
  providedIn: 'root'
})
export class CustomerEffortScoreService {
  constructor(private opportunityApiHttp: OpportunityApiHttp) {}
  submitCesSurvey(opportunityId: string, score: number): Observable<any> {
    const payload = {
      customerEffortScore: score
    };

    return this.opportunityApiHttp.put(
      `opportunities/${opportunityId}`,
      payload,
      ApiHttp.getStandardOptions()
    );
  }
}
